exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".App{display:flex;flex-direction:column;width:100%;height:100%;position:fixed;bottom:0;right:0}", ""]);
